import { render } from "./About.vue?vue&type=template&id=7e512be1"
const script = {}
script.render = render

export default script